module.exports = __webpack_public_path__ + "static/img/商品详情@2x.a324e9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/商品详情@2x.png
// module id = sgAE
// module chunks = 192